/**
 * Device key custody (Phase I interim — see risk R5 in the plan):
 * a secp256k1 keypair generated on first run, held in IndexedDB, never sent
 * anywhere except the public key at officer registration.
 */
import { generateKeyPair, type KeyPair } from "@vra/signing";
import { getStoredValue, setStoredValue } from "./db";

const KEY = "device-keypair";
const OFFICER = "officer-ref";

export async function getDeviceKeys(): Promise<KeyPair> {
  const existing = await getStoredValue<KeyPair>(KEY);
  if (existing) return existing;
  const fresh = generateKeyPair();
  await setStoredValue(KEY, fresh);
  return fresh;
}

export async function getOfficerRef(): Promise<string | undefined> {
  return getStoredValue<string>(OFFICER);
}

export async function setOfficerRef(ref: string): Promise<void> {
  await setStoredValue(OFFICER, ref);
}
